import { ReactNode } from "react";
import { StyleProp, View, ViewStyle } from "react-native";

const AnimatedAboveKeyboard = ({
	children,
	style,
}: {
	children?: ReactNode;
	style?: StyleProp<ViewStyle>;
}) => {
	return (
		<View
			style={[
				{
					position: "absolute",
					width: "100%",
					bottom: 10,
				},
				style,
			]}
		>
			{children}
		</View>
	);
};
export default AnimatedAboveKeyboard;
